import React from 'react';

// The portal's brand/status/verification mark: a hexagon outline filled with a
// status-token colour, glyph centred inside. This is one of the two icon tiers
// (footer §6 / account §2 / dashboard §6) – utility ACTIONS the user takes
// (email, call, help) use green rounded-square tiles instead; status, brand and
// verification use this hexagon. The illustrated growing-oak is reserved for
// celebration modals and is deliberately NOT this.
//
// Geometry matches the awarded-brief banner hexagon so every hexagon in the
// portal reads as one mark. `fg` is the token colour (stroke + glyph); the fill
// is that colour at low opacity. `glyph` is the inner SVG drawn on a 24×24
// grid – a nested SVG scales it into the hexagon's safe area, so callers can
// paste the same path data they'd use in any 24-grid line icon.
export default function StatusHexagon({ glyph, fg = '#009159', size = 34, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 44 44" fill="none" className={className} aria-hidden="true">
      <path
        d="M22 2.5 39.3 12v20L22 41.5 4.7 32V12z"
        fill={fg} fillOpacity="0.12" stroke={fg} strokeOpacity="0.55" strokeWidth="1.5" />
      {/* The hexagon's full-width safe band runs y=12..32 (width 34.6). A
          20×20 glyph box at (12,12) sits inside it on every side. */}
      <svg x="12" y="12" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke={fg} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
        {glyph}
      </svg>
    </svg>
  );
}
